import { render, staticRenderFns } from "./campaign.vue?vue&type=template&id=1e580e44&scoped=true&"
import script from "./campaign.vue?vue&type=script&lang=js&"
export * from "./campaign.vue?vue&type=script&lang=js&"
import style0 from "./campaign.vue?vue&type=style&index=0&id=1e580e44&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e580e44",
  null
  
)

export default component.exports